import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

interface FooterProps {
  variant?: 'landing' | 'dashboard';
}

function Footer({ variant = 'dashboard' }: FooterProps) {
  if (variant === 'landing') {
    return (
      <footer className="border-t border-border/50 mt-auto">
        <div className="mx-auto max-w-6xl px-4 py-10">
          <div className="flex flex-col gap-8 md:flex-row md:justify-between">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
                  <BookOpen className="h-4 w-4 text-primary-foreground" />
                </div>
                <span className="text-lg font-semibold text-foreground">Vocabbit</span>
              </div>
              <p className="max-w-xs text-sm text-muted-foreground">
                Master new vocabulary with AI-powered quizzes and intelligent learning.
              </p>
            </div>

            <div className="flex flex-wrap gap-12">

              <div className="space-y-3">
                <h4 className="text-sm font-medium text-foreground">Resources</h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="#" className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                      Help Center
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="space-y-3">
                <h4 className="text-sm font-medium text-foreground">Legal</h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="#" className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                      Privacy
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                      Terms
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 md:flex-row">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Vocabbit. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground">
              Made with ❤️ for language learners
            </p>
          </div>
        </div>
      </footer>
    );
  }

  // Dashboard footer (simple version)
  return (
    <footer className="border-t border-border/50 mt-auto">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="flex flex-col gap-8 items-center">
          <div className="mt-10 flex flex-col items-center gap-4 border-t border-border pt-6">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Vocabbit. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground">
              Made with ❤️ for language learners
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;